import React from 'react';
import { SingleSelectMenu } from '../../../../Dropdown';

interface IProps {
  isChurn: boolean;
  changeChurn: (newValue: boolean) => void;
}

const churnSelectorOptions = [
  {
    value: 'retention',
    text: 'Retention',
  },
  {
    value: 'churn',
    text: 'Churn',
  },
];

export default ({ isChurn, changeChurn }: IProps) => {
  const handleChange = (value: string) => {
    changeChurn(value === 'churn');
  };

  return (
    <SingleSelectMenu
      value={isChurn ? 'churn' : 'retention'}
      options={churnSelectorOptions}
      onChange={handleChange}
    />
  );
};
